export const FEE_RANGES = [
  { id: 0, rangeStart: 1, rangeEnd: 9.99 },
  { id: 1, rangeStart: 10, rangeEnd: 24.99 },
  { id: 2, rangeStart: 25, rangeEnd: 49.99 },
  { id: 3, rangeStart: 50, rangeEnd: 99.99 },
  { id: 4, rangeStart: 100, rangeEnd: 199.99 },
  { id: 5, rangeStart: 200, rangeEnd: 499.99 },
  { id: 6, rangeStart: 500, rangeEnd: -1 },
] as const;
